export const LEGAL_BRANDS = {
  inspiyah: { prefix: '', home: '/', homeLabel: 'Back to Home', privacy: 'privacy@inspiyah.com' },
  boc: { prefix: '/book-of-colorz', home: '/book-of-colorz', homeLabel: 'Back to The Book of Colorz', privacy: 'privacy@bookofcolorz.com' },
};

export const legalBrand = (brand) => LEGAL_BRANDS[brand] || LEGAL_BRANDS.inspiyah;
